import campaignStepData from './campaign-step-data.js';
import bigImageBlock from './big-image-block.js';
import cardMessage from './card-message.js';
import footer from './footer.js';
import header from './header.js';
import idCounts from './id-counts.js';
import title from './title.js';

export default {
  campaignStepData,
  bigImageBlock,
  cardMessage,
  footer,
  header,
  idCounts,
  title,
};
